import { EPlacementType } from 'shared/types/filters/advanced/placementType';

export const placementTypeMapLabel: Record<EPlacementType, string> = {
  [EPlacementType.StreetRetail]: 'Street retail',
  [EPlacementType.ShoppingMall]: 'В торговом комплексе',
};
